module.exports = __webpack_public_path__ + "ab607cd9.webp";